/**
 *
 * @module configurationClientHostParams
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class ConfigurationClientHostParams
 * @desc A model containing the ConfigurationClient's host params.
 *
 */
export default class ConfigurationClientHostParams {

    /**
     *
     * @param {String} baseUrl
     *
     */
    constructor(baseUrl) {

        const errorMessage = {
            ctor: 'ConfigurationClientHostParams(baseUrl)',
            get baseUrl() {
                return `${this.ctor} baseUrl should be a String with length`;
            }
        };

        nonEmptyString(baseUrl, errorMessage.baseUrl, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.baseUrl = baseUrl;

    }
}



// WEBPACK FOOTER //
// ./src/services/configuration/configurationClientHostParams.js